exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".feedback-item[data-v-021ecc22]{background-color:#6d6e71;border-radius:6px;padding:3px;font-size:12px;text-align:center;display:flex;flex-direction:column;justify-content:space-between;min-width:50px}.feedback-item.is-active[data-v-021ecc22]{border:1px solid #fff;box-sizing:border-box}.feedback-item__answer[data-v-021ecc22]{border-radius:0 0 3px 3px;height:20px}", ""]);

// exports
